"use client";

import React from "react";
import Container from "@/components/layout/Container";
import Flex from "@/components/layout/Flex";
import Section from "@/components/layout/Section";
import Headline from "@/components/project/Headline";
import Typography from "@/components/shared/Typography";
import Button from "@/components/ui/Button";
import { URLS } from "@/lib/consts";

function ErrorComponent({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const handleOnClick = React.useCallback(() => {
    reset();
  }, [reset]);

  React.useEffect(() => {
    throw new Error(error.message);
  }, [error]);

  return (
    <Flex.Column asChild justify="center" items="center">
      <Container asChild>
        <Section id="error" className="w-screen h-screen">
          <Headline>Something Broke...</Headline>
          <Typography.P className="text-center">
            We are sorry things are not working as expected. We hope to have it
            resolved soon.
          </Typography.P>

          <Typography.P className="text-center">
            In the mean time, please check your internet to make sure you are
            able to connect to the site.
          </Typography.P>

          <Typography.P>Thank you for understanding,</Typography.P>

          <Typography.P>
            The <span className="text-primary font-bold">Orsak CPAs</span> Team
          </Typography.P>

          <Flex.Column md="md:flex-row">
            <Button
              variant="secondary"
              onClick={handleOnClick}
              aria-label="Refresh the page"
            >
              Refresh Page
            </Button>
            <Button.Link href={URLS.HOME} aria-label="Return to home page">
              Take Me Home
            </Button.Link>
          </Flex.Column>
        </Section>
      </Container>
    </Flex.Column>
  );
}

export default ErrorComponent;
